import React, { useState } from 'react';
import { ThemeProvider, useTheme, createTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { GlobalRoutes } from './global/layout/GlobalRoutes';
import { CssBaseline } from '@mui/material';
import LoginPage from './components/Login/Login';

const drawerWidth = 240;

const useStyles = makeStyles(() => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: useTheme().spacing(2),
	},
	title: {
		flexGrow: 1,
	},
	appBar: {
		position: "static",
		width: `calc(100% - ${drawerWidth}px)`,
		marginLeft: drawerWidth,
	},
	content: {
		marginTop: "60px",
		marginLeft: `calc(${drawerWidth}px + 10px)`
	}
}));

const theme = createTheme({
	palette: {
		primary: {
			//main: '#06659d'
			main: '#2d55e6'
		},
		secondary: {
			main: '#2db1e6'
		},
	},
	typography: {
		htmlFontSize: 18
	}
});

function App() {
	const classes = useStyles();
	const [isLoggedIn, setIsLoggedIn] =  useState(false);
	const hasLoggedIn = () => setIsLoggedIn(true);

	return (
		<ThemeProvider theme={theme}>
			{ isLoggedIn ? 
				<div className={classes.root}>
					<CssBaseline />
					<GlobalRoutes />
				</div>
				:
				<LoginPage onSuccess={hasLoggedIn} />
			}
		</ThemeProvider>

	);
}

export default App;
